module.exports = __webpack_public_path__ + "static/media/loginicon.46a4ba59.png";